import React from "react";
import "../Components/css/Navbar.css";
import { AiFillBell } from "react-icons/ai";
import { BsPersonCircle } from "react-icons/bs";
import { FaShoppingCart } from "react-icons/fa";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
const Navbar = ({ title, icon }) => {
  const navigate = useNavigate();

  const handleSignOut = async (e) => {
    const auth = getAuth();
    e.preventDefault();
    try {
      let user = await signOut(auth);
      console.log(user);

      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <nav className="navbar navbar-expand-md navbar-dark bgColor">
        <a class="navbar-brand" href="#">
          <img src="/images/logoimg.png" className="logoDesign" alt="" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarNav">
          <ul className="navbar-nav pt-1">
            <li className="nav-item pr-3 active ">
              <a className="nav-link text-white " href="#">
                HOME <span className="sr-only">(current)</span>
              </a>
            </li>
            <li className="nav-item pr-3 ">
              <a className="nav-link text-white" href="#">
                MY ORDERS
              </a>
            </li>
            <li className="nav-item pr-3 ">
              <a className="nav-link text-white" href="#">
                MESSAGE
              </a>
            </li>
            <li className="nav-item pr-3 ">
              {title ? (
                <a className="nav-link text-white bg-danger pointer" onClick={handleSignOut}>
                  LOGOUT
                </a>
              ) : (
                <a className="nav-link text-white ">SIGN IN </a>
              )}
            </li>
          </ul>
          <div class="iconDiv align-items-center">
            {icon ? (
              <AiFillBell className="icon1" />
            ) : (
              <BsPersonCircle className="icon1" />
            )}
            <FaShoppingCart className="icon2" /> <BsPersonCircle />
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
